






import { defineComponent, computed, PropType } from '@vue/composition-api';
import { UserCreditData } from '@/pages/home/types';
import { getMajorQuotaText } from '@/pages/home/utils';

/**
 * 额度说明文案，如：可提现额度(元)、参考可借额度(元)、最高可借额度(元)
 */
export default defineComponent({
  name: 'MajorQuotaText',
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    isMiddleIncomeShow: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { userCreditData } = props;

    /** 额度说明文案 */
    const majorQuotaText = computed(() => getMajorQuotaText(userCreditData));

    return {
      majorQuotaText,
    };
  },
});
